import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, switchMap, take } from "rxjs/operators";
import { AngularFirestore, DocumentData, QueryFn } from '@angular/fire/firestore';
import { DataService } from '../data.service';
import { InventoryItemDTO } from 'src/app/models/results/inventory-item-dto';
import { AngularFireAuth } from '@angular/fire/auth';
import { environment } from 'src/environments/environment';
import { ResultConfigViewModel } from 'src/app/models/results/result-config-view-model';
import { constants } from 'src/environments/constants';
import { ILocaleInfo, UtilityService } from '../../utility.service';
import { ConnectionInventoryItem } from 'src/app/models/data/connection/connection-inventory-item';

@Injectable({
  providedIn: 'root'
})
export class ConnectionDataService implements DataService {

  constructor(
    private store: AngularFirestore,
    private auth: AngularFireAuth,
    private utilityService: UtilityService) { }

  updateResultConfigItem(item: ResultConfigViewModel): Promise<void> {
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  getAdminEmailAddresses(): Observable<string[]> {
    return of([]);
  }

  executeDatabaseQuery(): Observable<InventoryItemDTO[]> {
    const localeInfo: ILocaleInfo = this.utilityService.getLocaleInfo();

    const queryFn: QueryFn<DocumentData> = ref => ref.where('Locality', '==', localeInfo.localeName).where('Deleted', '==', false);

    return this.auth.user.pipe(
      take(1),
      switchMap(async user => {
        if (!user) {
          await this.auth.signInWithEmailAndPassword(environment.firebaseUserEmail, environment.firebase.apiKey);
        }
      }),
      switchMap(() => this.store.collection<ConnectionInventoryItem>(`${constants.FIRESTORE_INVENTORY_COLLECTION}_connection`, queryFn).valueChanges()),
      take(1),
      map((connectionItems: ConnectionInventoryItem[]) => {
        return connectionItems.map(connectionItem => this.mapDTO(connectionItem));
      })
    );
  }

  mapDTO(connectionItem: ConnectionInventoryItem): InventoryItemDTO {
    return Object.assign(new InventoryItemDTO(), {
      id: connectionItem.ID,
      hasBacklitKeyboard: connectionItem.BacklitKeyboard,
      hasFingerprintReader: connectionItem.HasFingerprintReader,
      hasPrivacyScreen: connectionItem.HasPrivacyScreen,
      hasStylus: connectionItem.HasStylus,
      cpuModel: connectionItem.CpuModel,
      diskDriveSize: connectionItem.DiskDriveSize,
      diskDriveUnit: connectionItem.DiskDriveUnit,
      diskDriveType: connectionItem.DiskDriveType,
      hasTouchscreen: connectionItem.HasTouchscreen,
      imageLargeLocation: connectionItem.ImageLarge,
      isEducation: connectionItem.IsEducation,
      isParallelsCapable: connectionItem.IsParallelsCapable,
      listPrice: ConnectionInventoryItem.getPrice(connectionItem),
      locality: connectionItem.Locality,
      manufactureName: connectionItem.ManufactureName,
      manufacturePart: connectionItem.ManufacturePart,
      materialID: connectionItem.MaterialID,
      memorySize: connectionItem.MemorySize,
      memoryUnit: connectionItem.MemoryUnit,
      name: connectionItem.ProductDescShort.split(' - ')[0],
      productDescLong: connectionItem.ProductDescLong,
      productDescShort: connectionItem.ProductDescShort,
      productLine: connectionItem.ProductLine,
      productType: connectionItem.ProductType,
      formattedScreenSize: connectionItem.ScreenSize,
      screenSize: ConnectionInventoryItem.getScreenSize(connectionItem),
      showInResults: connectionItem.ShowInResults,
      vendorURL: connectionItem.VendorURL
    });
  }
}
